<template>
  <section class="space-y-3 text-base text-black">
    <SeoAccordion>
      <template #title>
        {{ $t('seo.main.best-offers.title') }}
      </template>
      <template #default>
        <p>
          {{ $t('seo.main.best-offers.description') }}
        </p>
      </template>
    </SeoAccordion>
    <SeoAccordion>
      <template #title>
        {{ $t('seo.main.tour-types.title') }}
      </template>
      <template #default>
        <p v-for="(description, idx) in tourTypesDescriptions" :key="idx">
          {{ description }}
        </p>
      </template>
    </SeoAccordion>
    <SeoAccordion>
      <template #title>
        {{ $t('seo.main.ideal-tour.title') }}
      </template>
      <template #default>
        <p>
          {{ $t('seo.main.ideal-tour.description') }}
        </p>
      </template>
    </SeoAccordion>
    <SeoAccordion>
      <template #title>
        {{ $t('seo.main.advantages.title') }}
      </template>
      <template #default>
        <p>
          {{ $t('seo.main.advantages.description') }}
        </p>
      </template>
    </SeoAccordion>
    <SeoAccordion>
      <template #title>
        {{ $t('seo.main.how-to-use.title') }}
      </template>
      <template #default>
        <p v-for="(description, idx) in howToUseDescriptions" :key="idx">
          {{ description }}
        </p>
      </template>
    </SeoAccordion>
  </section>
</template>

<script setup lang="ts">
  import { useTranslation } from 'i18next-vue';
  import SeoAccordion from './SeoAccordion.vue';

  const { t } = useTranslation();

  /**
   * @see https://www.i18next.com/translation-function/objects-and-arrays
   */
  const tourTypesDescriptions = t('seo.main.tour-types.descriptions', {
    returnObjects: true,
  });

  const howToUseDescriptions = t('seo.main.how-to-use.descriptions', {
    returnObjects: true,
  });
</script>
